<template><router-view /></template>
<script>export default { name: "InventoryInboundDelivery" };</script>
